import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import './App.css'; 

import Referral from './Referral';
import TermsOfUs from './TermsOfUs';
import PrivacyPolicy from './PrivacyPolicy';
import LandingPage from './LandingPage';
import AccessibilityStatement from './AccessibilityStatement';
import NotFound from './NotFound';
import Home from './Home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/TermsOfUs" element={<TermsOfUs/>} />
        <Route path="/TermsOfUse" element={<TermsOfUs/>} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
        <Route path="/Terms-Of-Use" element={<TermsOfUs/>} />
        <Route path="/Terms-Of-Us" element={<TermsOfUs/>} />
        <Route path="/privacy-Policy" element={<PrivacyPolicy/>} />
        <Route path="/accessibilityStatement" element={<AccessibilityStatement/>} />
        <Route path="/feedbackRating" element={<Referral url={"https://forms.fillout.com/t/dn3BVhbdAnus"}/>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
  </BrowserRouter>
);

